<template>
  <div
    class="box"
    :class="{
      'info': type == 'info',
      'warning': type == 'warning',
      'danger': type == 'danger',
      'success': type == 'success'
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FeedbackMessage',
  props: {
    type: String
  }
}
</script>

<style scoped>
.box {
  display: flex;
  align-items: flex-start;
  padding: 3px 5px;
  border-radius: 3px;
  font-size: 15px;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  line-height: 1.4;
  background-color: #f5f5f5;
  border-left: 3px solid #9e9e9e;
  color: #424242;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}

.warning {
  background-color: #fef3cd;
  border-left: 3px solid #ffc107;
  color: #856404;
}

.danger {
  background-color: #f8d7da;
  border-left: 3px solid #dc3545;
  color: #721c24;
}

.info {
  background-color: #d1ecf1;
  border-left: 3px solid #17a2b8;
  color: #0c5460;
}

.success {
  background-color: #d4edda;
  border-left: 3px solid #28a745;
  color: #155724;
}
</style>